import { Page, DescriptionList } from '@shopify/polaris';
import { useGetServerInfo } from 'queries/utils.query';
import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
export default function ServerInfo() {
  const {
    data
  } = useGetServerInfo();
  const [serverData, setServerData] = useState([]);
  useEffect(() => {
    if (typeof data === 'object') {
      let dataforStoring = [];
      for (const key in data) {
        dataforStoring.push({
          key: key,
          value: data[key]
        });
      }
      setServerData(dataforStoring);
    }
  }, [data]);
  return <>
      <Helmet>
        <title>Server Info</title>
      </Helmet>
      <Page title="Server Info">
        <DescriptionList items={serverData?.map(item => ({
        term: item.key,
        description: item.value
      })) || []} />
      </Page>
    </>;
}